import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ComponentBase } from 'src/app/_utils/component.base';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent extends ComponentBase implements OnInit {
  @Input() fixed = false;

  isMobile;
  showFooter;

  constructor(private platform: Platform) {
    super();
  }

  async ngOnInit() {
    let user = await this.storage.get('user');
    this.isMobile = this.platform.is('mobile');

    //if (this.fixed) 
    
    setTimeout(() => {
      this.showFooter = !this.isMobile && user?.companyId == "-NoD5KwdjRoU06qfYC7t";
    }, 500);
  }

}
